let env = {};

env.baseURL = 'https://api.triagem-hml.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.triagem-hml.ares-saude.com.br/';
env.wsHost = 'websocket.triagem-hml.ares-saude.com.br';
env.wsPort = '443';
env.wsKey = 'triagem-hml-local-key';

export default env
